import css from "@css/modules/Listing.module.scss"
import cn from "classnames"
import { Fragment, useMemo } from "react"
import Link from "next/link"
import { getListingUrl } from "@utils/listingUrl"
import { addCurrency } from "@utils/index"
import { StartRating } from "@components/StartRating"
import { Listing, TopListing } from "@t/Listing"
import dayjs from "dayjs"

type Props = {
    notActive?: boolean
    listing: Listing
    topListings: TopListing[]
    title: string
}
const arrowDown = (
    <svg width="5" height="7" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.18728 6.60896C2.31199 6.73367 2.51418 6.73367 2.6389 6.60896L4.67118 4.57667C4.79589 4.45196 4.79589 4.24977 4.67118 4.12506C4.54647 4.00034 4.34427 4.00034 4.21956 4.12506L2.41309 5.93153L0.60661 4.12506C0.481899 4.00034 0.279702 4.00034 0.154991 4.12506C0.0302804 4.24977 0.0302804 4.45196 0.154991 4.57667L2.18728 6.60896ZM2.09374 0.742432L2.09374 6.38315H2.73243L2.73243 0.742432H2.09374Z"
            fill="white"
        />
    </svg>
)
function getMonth(month: string) {
    return dayjs("01 " + month + " 2022").format("MMM")
}

export function DealScoreTable({ listing, topListings, title, notActive = false }: Props) {
    const dontNeedCurrent = useMemo(() => topListings.some((top) => top.id === listing.id), [topListings, listing.id])

    return (
        <>
            <h3 className={css.dealScoreTableTitle}>
                <span>{title}</span>
            </h3>
            <div className={css.dealScoreTable}>
                <div className={css.gridRow1Holder} />
                <div className={cn(css.gridRow1, css.gridColl1)}>Rank</div>
                <div className={cn(css.gridRow1, css.gridColl2)}>Month</div>
                <div className={cn(css.gridRow1, css.gridColl3)}>Pts.</div>
                <div className={cn(css.gridRow1, css.gridColl4)}>$/pt</div>
                <div className={cn(css.gridRow1, css.gridColl5)}>Deal Score</div>
                <div className={css.gridSpacer} />
                {topListings.map((topListing) => (
                    <Fragment key={topListing.id}>
                        {topListing.id === listing.id && <div className={css.gridSeparatorTop} />}
                        <div className={cn(css.gridRow, css.gridColl1, topListing.id === listing.id && css.gridCellCurrent)}>
                            {topListing.id !== listing.id && (
                                <Link
                                    href={getListingUrl({
                                        id: topListing.id,
                                        resort: listing.resort
                                    })}
                                    className={css.gridLink}>
                                    ID: {topListing.id} {listing.resort.short_name}
                                </Link>
                            )}
                            {topListing.rank}
                        </div>
                        <div className={cn(css.gridRow, css.gridColl2)}>{getMonth(topListing.use_month)}</div>
                        <div className={cn(css.gridRow, css.gridColl3)}>{topListing.points_on_contract}</div>
                        <div className={cn(css.gridRow, css.gridColl4)}>{addCurrency(topListing.price_per_point)}</div>
                        <div className={cn(css.gridRow, css.gridColl5)}>
                            <StartRating rating={topListing.stars || 1} size={12.5} gap={4.6} />
                        </div>
                        {topListing.id === listing.id && <div className={css.gridSeparatorBottom} />}
                    </Fragment>
                ))}
                {!dontNeedCurrent && !notActive && (
                    <Fragment>
                        <div className={cn(css.gridArrow, css.gridColl1)}>{arrowDown}</div>
                        <div className={cn(css.gridArrow, css.gridColl2)}>{arrowDown}</div>
                        <div className={cn(css.gridArrow, css.gridColl3)}>{arrowDown}</div>
                        <div className={cn(css.gridArrow, css.gridColl4)}>{arrowDown}</div>
                        <div className={cn(css.gridArrow, css.gridColl5)}>{arrowDown}</div>
                        <div className={css.gridSeparatorTop} />
                        <div className={cn(css.gridRow, css.gridCellCurrent, css.gridColl1)}>{listing.rank}</div>
                        <div className={cn(css.gridRow, css.gridColl2)}>{getMonth(listing.use_month)}</div>
                        <div className={cn(css.gridRow, css.gridColl3)}>{listing.points_on_contract}</div>
                        <div className={cn(css.gridRow, css.gridColl4)}>{addCurrency(listing.price_per_point)}</div>
                        <div className={cn(css.gridRow, css.gridColl5)}>
                            <StartRating rating={listing.stars || 1} size={12.5} gap={4.6} />
                        </div>
                    </Fragment>
                )}
            </div>
        </>
    )
}
